module.exports = __webpack_public_path__ + "img/web-04.5a3b02d2.png";